module.exports = __webpack_public_path__ + "images/emoji/bar_chart.4c4554b8a0e449c8977c.png";